(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptLanguageDialogController', RptLanguageDialogController);

    RptLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RptLanguage'];

    function RptLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RptLanguage) {
        var vm = this;

        vm.rptLanguage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rptLanguage.id !== null) {
                RptLanguage.update(vm.rptLanguage, onSaveSuccess, onSaveError);
            } else {
                RptLanguage.save(vm.rptLanguage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:rptLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
